import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import alertsEpics from './Alerts/epics'
import customizationEpics from './Customization/epics'
import customizationO365Epics from './CustomizationO365/epics'
import deepfakeGeneralEpics from './DeepFakeGeneral/epics'
import disclaimersEpics from './Disclaimers/epics'
import emailServerEpics from './EmailServer/epics'
import gsuiteEpics from './EmailServer/Gsuite/epics'
import o365Epics from './EmailServer/O365/epics'
import quickIntegrationEpics from './EmailServer/QuickIntegration/epics'
import generalEpics from './General/epics'
import incidentResponseEpics from './Incidence/epics'
import intelligenceEpics from './Intelligence/epics'
import spamAllowListEpics from './Intelligence/SpamAllowList/epics'
import languagesEpics from './Languages/epics'
import mailboxProtectionEpics from './MailboxProtection/epics'
import sightsLandingFormEpics from './MailboxProtection/LandingForm/epics'
import malwareDetectionEpics from './MalwareDetection/epics'
import microsoftQuarantineEpics from './MicrosoftQuarantine/epics'
import collaborationAppsNotificationsEpics from './Notifications/CollaborationApps/epics'
import endUserNotificationsEpics from './Notifications/EndUser/epics'
import systemNotificationsEpics from './Notifications/System/epics'
import partnerSettingsEpics from './PartnerSettings/epics'
import profileSettingsEpics from './ProfileSettings/epics'
import pushNotificationsEpics from './ProfileSettings/PushNotifications/epics'
import simulatorEpics from './Simulator/epics'
import usersEpics from './Users/epics'
import whitelistEpics from './Whitelist/epics'
import { fetchGroupSettingsNameError, fetchGroupSettingsNameSuccess } from './actions'
import { GROUP_SETTINGS_NAME_REQUEST_ASYNC } from './constants'

const getGroupSettingsNameEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(GROUP_SETTINGS_NAME_REQUEST_ASYNC.INITIATE).switchMap(() =>
    api.settings
      .getGroupSettingsName(store.getState().partnerOptions.selectedCompany?.value)
      .map((response) => fetchGroupSettingsNameSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(fetchGroupSettingsNameError, error)))
  )

export default combineEpics(
  profileSettingsEpics,
  pushNotificationsEpics,
  generalEpics,
  usersEpics,
  whitelistEpics,
  languagesEpics,
  partnerSettingsEpics,
  incidentResponseEpics,
  intelligenceEpics,
  spamAllowListEpics,
  mailboxProtectionEpics,
  sightsLandingFormEpics,
  simulatorEpics,
  malwareDetectionEpics,
  alertsEpics,
  emailServerEpics,
  quickIntegrationEpics,
  gsuiteEpics,
  o365Epics,
  systemNotificationsEpics,
  endUserNotificationsEpics,
  collaborationAppsNotificationsEpics,
  customizationEpics,
  customizationO365Epics,
  disclaimersEpics,
  microsoftQuarantineEpics,
  getGroupSettingsNameEpic,
  deepfakeGeneralEpics
)
